/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$defineProperties = _interopDefault(require('babel-runtime/core-js/object/define-properties'));
var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var Geolocation = __ol.Geolocation;
var props = {
  tracking: {
    type: Boolean,
    default: true
  },
  trackingOptions: Object
  // todo add autoCenter, bindToPosition
};

var computed = {
  accuracy: function accuracy() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getAccuracy();
    }
  },
  altitude: function altitude() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getAltitude();
    }
  },
  altitudeAccuracy: function altitudeAccuracy() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getAltitudeAccuracy();
    }
  },
  heading: function heading() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getHeading();
    }
  },
  position: function position() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getPosition();
    }
  },
  speed: function speed() {
    if (this.rev && this.$geolocation) {
      return this.$geolocation.getSpeed();
    }
  }
};

var methods = {
  /**
   * @return {ol.Geolocation}
   * @private
   */
  createOlObject: function createOlObject() {
    return new Geolocation({
      tracking: this.tracking,
      trackingOptions: this.trackingOptions,
      projection: core.EPSG_4326
    });
  },

  /**
   * @return {void}
   * @private
   */
  mount: function mount() {
    this.subscribeAll();
  },

  /**
   * @return {void}
   * @private
   */
  unmount: function unmount() {
    core.assert.hasGeolocation(this);

    this.unsubscribeAll();
    this.$geolocation.setTracking(false);
  },

  /**
   * @return {void}
   * @protected
   */
  subscribeAll: function subscribeAll() {
    subscribeToGeolocation.call(this);
  }
};

var watch = {
  /**
   * @param {boolean} value
   */
  tracking: function tracking(value) {
    if (this.$geolocation && value !== this.$geolocation.getTracking()) {
      this.$geolocation.setTracking(value);
    }
  },
  tracingOptions: function tracingOptions(value) {
    this.$geolocation && this.$geolocation.setTrackingOptions(value);
  }
};

var Geoloc = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('i', { class: [_vm.$options.name], staticStyle: { "display": "none !important" } }, [_vm._t("default", null, { accuracy: _vm.accuracy, altitude: _vm.altitude, altitudeAccuracy: _vm.altitudeAccuracy, heading: _vm.heading, position: _vm.position, speed: _vm.speed })], 2);
  }, staticRenderFns: [],
  name: 'vl-geoloc',
  mixins: [core.olCmp, core.useMapCmp],
  props: props,
  computed: computed,
  methods: methods,
  watch: watch,
  stubVNode: {
    empty: function empty() {
      return this.$options.name;
    }
  },
  created: function created() {
    var _this = this;

    _Object$defineProperties(this, {
      /**
       * @type {ol.Geolocation|undefined}
       */
      $geolocation: {
        enumerable: true,
        get: function get() {
          return _this.$olObject;
        }
      },
      $map: {
        enumerable: true,
        get: function get() {
          return _this.$services && _this.$services.map;
        }
      }
    });
  }
};

/**
 * @return {void}
 * @private
 */
function subscribeToGeolocation() {
  var _this2 = this;

  core.assert.hasGeolocation(this);

  var ft = 100;
  var changes = core.observableFromOlChangeEvent(this.$geolocation, ['accuracy', 'altitude', 'altitudeaccuracy', 'heading', 'position', 'speed'], true, ft);

  this.subscribeTo(changes, function (_ref) {
    var prop = _ref.prop,
        value = _ref.value;

    ++_this2.rev;
    _this2.$emit('update:' + prop, value);
  });
}

var index = {
  Geoloc: Geoloc,
  install: function install(Vue) {
    Vue.component(Geoloc.name, Geoloc);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/geoloc/index.js
// module id = 1181
// module chunks = 1